var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"event__add-btn btn--circle",attrs:{"type":"button"}},_vm.$listeners),[_c('span',{staticClass:"event__add-icon material-icons text-blue"},[_vm._v(" add ")])])}
var staticRenderFns = []

export { render, staticRenderFns }